export default __webpack_public_path__ + "static/logo-purple-cfe91381fbc57e48ed5b4a28a88330ef.svg";